import { EProductEditions } from 'enums/EProductEditions';
import { useRMSelector } from 'redux/hooks';
import { selectProductEdition } from 'redux/selectors/StateSelectors';
import useRMLite from './useRMLite';

// RM Lite has its own feature set, so it never inherits the RM license edition restrictions
const RM_LITE_EFFECTIVE_EDITION = EProductEditions.Enterprise;

const useProductEdition = (): EProductEditions => {
  const licenseEdition = useRMSelector(selectProductEdition);
  const rmLite = useRMLite();
  return rmLite ? RM_LITE_EFFECTIVE_EDITION : licenseEdition;
};

export default useProductEdition;
